<div class="row mb-3">
  <p class="title h4 mb-3">Statistiche</p>
</div>
<div class="row mt-3">
  <div class="col-3">
               <it-select
                  id="default-select"
                  label="Selezionare la statistica che si desidera visualizzare"
                  [(ngModel)]="statistic"
                >
                  <option [value]="'SETTING'"> Statistica per setting</option>
                  <option [value]="'ENTITY_COMPRESS'" *ngIf="authService.isOperatoreSuperUser || authService.isOperatoreCot"> Pratiche segnalante da ogni nodo</option>
                  <option [value]="'ENTITY_MANAGE'" *ngIf="authService.isOperatoreSuperUser || authService.isOperatoreCot"> Pratiche gestite da ogni nodo</option>
                  <option [value]="'ENTITY_EXPLODED'" *ngIf="authService.isOperatoreSuperUser || authService.isOperatoreCot"> Statistica per entità esplosa segnalante</option>
                  <option [value]="'ENTITY_EXPLODED_MANAGE'" *ngIf="authService.isOperatoreSuperUser || authService.isOperatoreCot"> Statistica per entità esplosa gestore</option>
                </it-select>
  </div>
  <div class="col-9" *ngIf="false">
    <p *ngIf="statistic === 'SETTING'">
      <a
        tabindex="0"
        role="button"
        popoverTrigger="focus"
        data-container="body"
        data-bs-placement="bottom"
        popoverTitle="Info"
        itPopover="La statistica mostra il numero di pratiche e di pazienti, divisi per ASL e per l'intera regione, associati a ciascun setting. Nella sezione 'Altro' sono conteggiate quelle pratiche per cui il setting è Post Acuzie non specificato, oppure che sono state create con la modalità del vecchio applicativo e non è stato inserito un setting riconducibile a una categoria esplicita.">
        <it-icon name="info-circle"></it-icon>
      </a> La tabella mostra il numero di pratiche e di pazienti gestiti tramite la piattaforma GPC, con distribuzione per ciascun setting di assistenza.</p>
    <p *ngIf="statistic === 'ENTITY_COMPRESS'"> <a
        tabindex="0"
        role="button"
        popoverTrigger="focus"
        data-container="body"
        data-bs-placement="bottom"
        popoverTitle="Info"
        itPopover="La statistica mostra il numero di pratiche create da ciascuna entità segnalante. Ogni colonna rappresenta il setting di appartenenza della pratica. Nella sezione 'Tutti i setting' è conteggiato il totale delle pratiche create indipendentemente dal setting. Nella sezione 'Altro' sono conteggiate quelle pratiche per cui il setting è Post Acuzie non specificato, oppure che sono state create con la modalità del vecchio applicativo e non è stato inserito un setting riconducibile a una categoria esplicita.">
        <it-icon name="info-circle"></it-icon>
      </a> Viene visualizzato il numero di pratiche registrate da ciascuna entità segnalante (Bed Manager, COT, MMG/PLS, REPARTI)</p>
    <p *ngIf="statistic === 'ENTITY_MANAGE'"><a
        tabindex="0"
        role="button"
        popoverTrigger="focus"
        data-container="body"
        data-bs-placement="bottom"
        popoverTitle="Info"
        itPopover="La statistica mostra il numero di pratiche gestite da ciascuna tipologia di entità. Ogni colonna rappresenta il setting di appartenenza della pratica. Nella sezione 'Tutti i setting' è conteggiato il totale delle pratiche create indipendentemente dal setting. Nella sezione 'Altro' sono conteggiate quelle pratiche per cui il setting è Post Acuzie non specificato, oppure che sono state create con la modalità del vecchio applicativo e non è stato inserito un setting riconducibile a una categoria esplicita. Per 'gestione della pratica' si intende che è stato fatto almeno un passaggio di competenza alla tipologia di entità riportata in ciascuna riga.">
        <it-icon name="info-circle"></it-icon>
      </a>  Viene visualizzato il numero di pratiche gestite da ciascuna entità (Bed Manager, COT, MMG/PLS, PUA, REPARTI, UVCP, UVMD/UVMO)</p>
    <p *ngIf="statistic === 'ENTITY_EXPLODED'"><a
        tabindex="0"
        role="button"
        popoverTrigger="focus"
        data-container="body"
        data-bs-placement="bottom"
        popoverTitle="Info"
        itPopover="La statistica mostra il numero di pratiche create da ciascuna entità segnalante. Ogni colonna rappresenta il setting di appartenenza della pratica. Nella sezione 'Tutti i setting' è conteggiato il totale delle pratiche create indipendentemente dal setting. Nella sezione 'Altro' sono conteggiate quelle pratiche per cui il setting è Post Acuzie non specificato, oppure che sono state create con la modalità del vecchio applicativo e non è stato inserito un setting riconducibile a una categoria esplicita. Ogni riga riporta il dettaglio dell'entità che ha creato la pratica con indicazione della ASL; tali entità sono ordinate per categoria ed in ordine alfabetico">
        <it-icon name="info-circle"></it-icon>
      </a>  La tabella riporta in dettaglio il numero di pratiche segnalate per ciascuna entità segnalante.</p>
    <p *ngIf="statistic === 'ENTITY_EXPLODED_MANAGE'"><a
        tabindex="0"
        role="button"
        popoverTrigger="focus"
        data-container="body"
        data-bs-placement="bottom"
        popoverTitle="Info"
        itPopover="La statistica mostra il numero di pratiche gestite da ciascuna tipologia di entità. Ogni colonna rappresenta il setting di appartenenza della pratica. Nella sezione 'Tutti i setting' è conteggiato il totale delle pratiche create indipendentemente dal setting. Nella sezione 'Altro' sono conteggiate quelle pratiche per cui il setting è Post Acuzie non specificato, oppure che sono state create con la modalità del vecchio applicativo e non è stato inserito un setting riconducibile a una categoria esplicita. Per 'gestione della pratica' si intende che è stato fatto almeno un passaggio di competenza alla tipologia di entità riportata in ciascuna riga. Ogni riga riporta il dettaglio dell'entità che ha creato la pratica con indicazione della ASL; tali entità sono ordinate per categoria ed in ordine alfabetico">
        <it-icon name="info-circle"></it-icon>
      </a> La tabella riporta in dettaglio il numero di pratiche gestite per ciascuna entità gestore: ovvero tutte le entità che gestiscono una pratica.</p>
  </div>
</div>
<div class="row mt-3" *ngIf="statistic === 'SETTING'">
  <div class="col">
      <app-stats-table></app-stats-table>
  </div>
</div>
<div class="row" *ngIf="statistic === 'ENTITY_COMPRESS'">
  <div class="col">
      <app-stats-table-entity-compress></app-stats-table-entity-compress>
  </div>
</div>
<div class="row" *ngIf="statistic === 'ENTITY_MANAGE'">
  <div class="col">
      <app-stats-table-entity-manage></app-stats-table-entity-manage>
  </div>
</div>
<div class="row" *ngIf="statistic === 'ENTITY_EXPLODED'">
  <div class="col">
      <app-stats-table-entity-exploded></app-stats-table-entity-exploded>
  </div>
</div>
<div class="row" *ngIf="statistic === 'ENTITY_EXPLODED_MANAGE'">
  <div class="col">
      <app-stats-table-entity-exploded-manage></app-stats-table-entity-exploded-manage>
  </div>
</div>